import React from 'react';
import { Fab, Zoom } from '@mui/material';
import { Save as SaveIcon, Check as CheckIcon } from '@mui/icons-material';

interface FloatingSaveButtonProps {
    onSave: () => void;
    isMobile?: boolean;
    showSuccess?: boolean;
}

const FloatingSaveButton: React.FC<FloatingSaveButtonProps> = ({
    onSave,
    isMobile = false,
    showSuccess = false
}) => {
    // Button should always be visible
    return (
        <Zoom in={true}>
            <Fab
                color="primary"
                aria-label="save"
                onClick={onSave}
                sx={{
                    position: 'fixed',
                    bottom: isMobile ? 16 : 32,
                    right: isMobile ? 16 : 32,
                    zIndex: 1000,
                    transition: 'all 0.3s ease-in-out',
                    ...(showSuccess && {
                        bgcolor: 'success.main',
                        '&:hover': {
                            bgcolor: 'success.dark',
                        },
                    }),
                }}
                size={isMobile ? 'medium' : 'large'}
            >
                {showSuccess ? <CheckIcon /> : <SaveIcon />}
            </Fab>
        </Zoom>
    );
};

export default FloatingSaveButton;
